import { useContextStrict } from 'hooks/useContextStrict';
import { ServicesContext } from 'contexts/ServicesContext';

export const useServices = () => {
  return useContextStrict(ServicesContext);
};
